import { useTheme } from "@/lib/theme"
import { useEffect, useState } from "react"

export function ThemeToggle() {
    const { setTheme, theme } = useTheme()
    const [isDark, setIsDark] = useState(false)

    useEffect(() => {
        setIsDark(theme === "dark")
    }, [theme])

    const toggleTheme = () => {
        const newTheme = isDark ? "light" : "dark"
        setTheme(newTheme)
    }

    return (
        <div
            className="relative flex items-center justify-between w-[140px] h-10 rounded-full bg-secondary p-1 cursor-pointer border border-border shadow-inner"
            onClick={toggleTheme}
            role="switch"
            aria-checked={isDark}
            aria-label="Toggle theme"
        >
            {/* Text Labels - Behind layer */}
            <div className="absolute inset-0 flex items-center justify-between px-5 w-full h-full pointer-events-none z-10">
                <span className={`text-xs font-bold uppercase tracking-wider transition-colors duration-300 ${isDark ? 'text-muted-foreground' : 'text-foreground'}`}>Light</span>
                <span className={`text-xs font-bold uppercase tracking-wider transition-colors duration-300 ${isDark ? 'text-foreground' : 'text-muted-foreground'}`}>Dark</span>
            </div>

            {/* Sliding Thumb */}
            <div
                className={`relative z-0 h-8 w-[64px] bg-background rounded-full shadow-md border border-border/50 transition-transform duration-500 ${isDark ? "translate-x-[68px]" : "translate-x-0"}`}
                style={{ transitionTimingFunction: "cubic-bezier(0.175, 0.885, 0.32, 1.275)" }}
            />
        </div>
    )
}
